<template>
  <el-button class="d2-mr btn-text can-hover" type="text" @click="handleClick">
    <!-- <d2-icon name="search" style="font-size: 18px;"/> -->
    <i class="iconfont iconnav_sousuo" style="font-size:16px"/>
  </el-button>
</template>

<script>
export default {
  methods: {
    handleClick () {
      this.$emit('click')
    }
  }
}
</script>

<vue-filename-injector>
export default function (Component) {
  Component.options.__source = "src/layout/header-aside/components/header-search/index.vue"
}
</vue-filename-injector>
